import 'antd/dist/antd.min.css'
import { Form, Input, Button, Row, Col } from 'antd';
import ImgSrc from 'assets/buy_the_mile_logo.png'

export default function LoginForm({ onSubmit }) {

  const onFinish = (values) => {
    onSubmit({
      username: values.username,
      password: values.password
    });
  };

  return (
    <>
      <Row type="flex" justify="center" align="stretch" style={{ minHeight: '25vh' }}>
        <Col style={{ marginTop: 40 }} >
          <img width="300" src={ImgSrc} alt="Buy the mile logo" />
        </Col>
      </Row>
      <Row type="flex" justify="center" style={{ minHeight: '40vh' }}>
        <Col >
          <Form
            name="basic"
            labelCol={{
              span: 11,
            }}
            wrapperCol={{
              span: 16,
            }}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            <Form.Item
              label="Όνομα Χρήστη"
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ τοποθετήστε το Όνομα Χρήστη',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Κωδικός Πρόσβασης:"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Παρακαλώ τοποθετήστε το Κωδικό Πρόσβασης',
                },
              ]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 16,
              }}
            >
              <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }}>
                Σύνδεση
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </>
  );
}

